import { render, staticRenderFns } from "./StarterTypeManager.vue?vue&type=template&id=36b10b82&"
import script from "./StarterTypeManager.vue?vue&type=script&lang=ts&"
export * from "./StarterTypeManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports